import PropTypes from "prop-types";
import React from "react";
import {Col, Container, Row,} from "reactstrap";
import {Link} from "react-router-dom";

// Pages Components
import LatestTranaction from "./Team";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import {withTranslation} from "react-i18next";

//redux

const Team = props => {

  //meta title
  document.title = "Team | Temperstack";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Row>
            <Col lg="10">
              <Breadcrumbs
                title={props.t("Teams")}
                breadcrumbItem={props.t("Teams")}
              />
            </Col>
            <Col lg="2">
              <Link
                to="/add-service"
                className="btn btn-primary bx-pull-right w-md"
              >
                Add Team
              </Link>
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <LatestTranaction/>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Team.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Team);
